import { useEffect } from "react";

// Sets page title + meta description, restores them on unmount.
export function useSeo(title, description) {
  useEffect(() => {
    if (!title) return undefined;
    const prev = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta?.getAttribute("content");
    document.title = title;
    if (description) meta?.setAttribute("content", description);
    return () => { document.title = prev; if (meta && prevDesc) meta.setAttribute("content", prevDesc); };
  }, [title, description]);
}
